/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menureadinghint2Inputs */

const en_menureadinghint2 = /** @type {(inputs: Menureadinghint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This usually takes a minute or two. Credits are only charged after a successful reading.`)
};

const de_menureadinghint2 = /** @type {(inputs: Menureadinghint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das dauert meist ein bis zwei Minuten. Credits werden erst abgebucht, wenn das Einlesen geklappt hat.`)
};

/**
* | output |
* | --- |
* | "This usually takes a minute or two. Credits are only charged after a successful reading." |
*
* @param {Menureadinghint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menureadinghint2 = /** @type {((inputs?: Menureadinghint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menureadinghint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menureadinghint2(inputs)
	return de_menureadinghint2(inputs)
});
export { menureadinghint2 as "menuReadingHint" }